export const SET_CODE = (state, value) => {
  state.code = value
}

export const SET_DESCRIPTION = (state, value) => {
  state.description = value
}

export const SET_NAME = (state, value) => {
  state.name = value
}

export const SET_FIRSTNAME = (state, value) => {
  state.firstname = value
}

export const SET_LASTNAME = (state, value) => {
  state.lastname = value
}
